import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { HeaderKey } from "@shared/clickar-constants";
import { TopCms } from "@shared/model/top-cms";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class OpenApiService {
	protected httpClient = inject(HttpClient);

	private basePath = environment.baseApiUrl;
	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();

	constructor() {
		const configuration = inject(Configuration, { optional: true });

		if (configuration) {
			this.configuration = configuration;
			this.basePath ??= configuration.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains "multipart/form-data", false: otherwise
	 */
	/* private canConsumeForm(consumes: string[]): boolean {
		const form = "multipart/form-data";
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	} */

	/**
	 * getTopCms
	 *
	 * @param idUser idUser
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getTopCms(idMarket: string, lang: string, observe?: "body", reportProgress?: boolean): Observable<TopCms[]> {

		if (idMarket === null || idMarket === undefined) {
			throw new Error("Required parameter idMarket was null or undefined when calling getUserUsingGET.");
		}

		if (lang === null || lang === undefined) {
			throw new Error("Required parameter lang was null or undefined when calling getUserUsingGET.");
		}

		let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("mkt", <any>idMarket);
		}
		if (lang !== undefined && lang !== null) {
			queryParameters = queryParameters.set("lang", <any>lang);
		}

		let headers = this.defaultHeaders;

		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(["*/*"]);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected)
				.set(HeaderKey.NO_SPIN, "true");
		}

		return this.httpClient.get<TopCms[]>(
			`${this.basePath}/api/v1/open/top-cms`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		).pipe(map(b => (b || [])
			.map(c => {
				c = Object.assign(new TopCms(), c);
				c.setImage(c.image);
				c.setImage(c.imageTablet, "Tablet");
				c.setImage(c.imageMobile, "Mobile");
				return c;
			}))
		);
	}
}